/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var breakPointPC = 1279;
	var breakPointSP = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// toggleQuestion
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleQuestion = function toggleQuestion() {
	  var targetButtons = document.querySelectorAll('.idx-Campaign_Question_Button');
	  var targetContents = document.querySelectorAll('.idx-Campaign_Question_Content');
	  var targetButtonsArray = Array.prototype.slice.call(targetButtons, 0);
	  targetButtonsArray.forEach(function (targetButton, index) {
	    targetButton.addEventListener('click', function () {
	      if (targetButton.classList.contains('is-Close')) {
	        targetButton.classList.remove('is-Close');
	        setTimeout(function () {
	          targetContents[index].classList.remove('is-Close-H');
	        }, 0);
	        setTimeout(function () {
	          targetContents[index].classList.remove('is-Close-O');
	        }, 325);
	      } else {
	        targetButton.classList.add('is-Close');
	        setTimeout(function () {
	          targetContents[index].classList.add('is-Close-O');
	        }, 0);
	        setTimeout(function () {
	          targetContents[index].classList.add('is-Close-H');
	        }, 325);
	      }
	    }, false);
	  });
	};
	
	(function () {
	  toggleQuestion();
	  (0, _module.visibleButton)();
	  (0, _module.anchorLink)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPointPC = 1279;
	var breakPointSP = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// visibleButton
	// ----- BOTH
	// ------------------------------------------------------------------------
	var visibleButton = function visibleButton() {
	  var targetButton = document.querySelector('.sw-Top');
	  var targetHeight = 100;
	  window.addEventListener('scroll', function () {
	    var scrollHeight = window.pageYOffset;
	    if (scrollHeight > targetHeight) {
	      targetButton.classList.remove('is-Hidden');
	    } else {
	      targetButton.classList.add('is-Hidden');
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	exports.visibleButton = visibleButton;
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 31collabo/app.bundle.js